import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import React from "react";
import ServerErrorIcon from "src/assets/illustrations/server_error.svg?react";
import { HeadingV2 } from "src/components/HeadingV2/HeadingV2.tsx";
import * as styles from "./InternalServerError.style.ts";
import { Flex } from "src/components/Flex.tsx";
import { useTranslation } from "react-i18next";

import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";
await loadTranslations(TranslationNamespaceEnum.InternalServerError);

export const InternalServerError = ({ onReset }: { onReset?: () => void }) => {
  const { t } = useTranslation(TranslationNamespaceEnum.InternalServerError);
  return (
    <div css={styles.root}>
      <div css={styles.inner}>
        <Flex
          style={{
            minHeight: "0px",
          }}
          flexShrink={0}
          gap={"30px"}
          alignItems={"center"}
        >
          <div>
            <ServerErrorIcon />
          </div>
          <div>
            <div css={styles.errorCode}>500</div>
            <HeadingV2 css={styles.heading} color={"red.500"} h={1}>
              {t("title")}
            </HeadingV2>
          </div>
        </Flex>
        <Flex
          style={{
            minHeight: "0px",
          }}
          flexShrink={0}
          css={styles.description}
        >
          <TextV2 variant={"body1"}>{t("description")}</TextV2>
        </Flex>
        <Flex
          flexShrink={0}
          style={{
            marginTop: "30px",
            minHeight: "0px",
          }}
        >
          <ButtonV2
            onClick={onReset}
            variant={"filled"}
            startAdornment={<i className={"icon-15-update"} />}
          >
            {t("action")}
          </ButtonV2>
        </Flex>
      </div>
    </div>
  );
};
